import React, { Component } from 'react'
import { withRouter, Link } from 'react-router'
import { connect } from 'react-redux'
import { handleGameClick, handleErrorCode, showErrorMessage, renderGame } from '../GamesPageNewLayout/gameUtils.jsx'
import SignIn from '../../header/SignIn.jsx'
import { FormattedMessage } from 'react-intl'
import { messages } from '../GamesPageNewLayout/messages.js'
import Loader from '../../../../shared/components/Loader.jsx'

class GameTypesPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      games: [],
      category: null,
      isLoading: true,
      showSignIn: false,
      favoriteGames: this.getFavoriteGamesFromStorage() || [],
      page: 1,
      limit: 18,
      hasMoreGames: true,
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    const { categoryId } = this.props.params
    console.log('Mount categoryId:', categoryId)
    this.fetchGamesByCategory(categoryId)
    this.setState({ category: categoryId || 'Категория' })

    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    // Clean up the scroll event listener
    window.removeEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate(prevProps) {
    const { categoryId } = this.props.params
    console.log('Updated categoryId:', categoryId)
    if (prevProps.params.categoryId !== categoryId) {
      this.setState({ category: categoryId, page: 1, games: [], hasMoreGames: true }, () => {
        this.fetchGamesByCategory(categoryId)
      })
    }
  }

  handleScroll() {
    const { isLoading, hasMoreGames } = this.state
    // Check if we are near the bottom of the page
    if (
      window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50 &&
      !isLoading &&
      hasMoreGames
    ) {
      this.handleLoadMoreGames()
    }
  }

  handleLoadMoreGames() {
    const { categoryId } = this.props.params

    if (!categoryId) {
      console.error('Category ID is not defined')
      return
    }

    this.setState(prevState => {
      const newPage = prevState.page + 1
      console.log('New Page:', newPage)

      this.fetchGamesByCategory(categoryId, newPage, true)

      return { page: newPage }
    })
  }

  fetchGamesByCategory = async (categoryId, page = 1, append = false) => {
    const { limit, games } = this.state
    this.setState({ isLoading: true })

    try {
      const offset = (page - 1) * limit
      const response = await fetch(`/api/games/all-games?types=${categoryId}&limit=${limit}&offset=${offset}`)
      const data = await response.json()
      console.log('Fetched data:', data)

      const newGames = data.Items.filter(newGame => !games.some(existingGame => existingGame.Id === newGame.Id))

      this.setState(prevState => ({
        games: append ? [...prevState.games, ...newGames] : newGames,
        isLoading: false,
        hasMoreGames: newGames.length === limit,
      }))
    } catch (error) {
      console.error('Failed to fetch games by category:', error)
      this.setState({ isLoading: false })
    }
  }

  openAuthModal = () => {
    const { user } = this.props

    if (user) {
      alert('Игра не доступна')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })

    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, () => this.openAuthModal())
    )
  }

  saveFavoriteGamesToStorage = favoriteGames => {
    localStorage.setItem('favoriteGames', JSON.stringify(favoriteGames))
  }

  getFavoriteGamesFromStorage = () => {
    try {
      const favorites = localStorage.getItem('favoriteGames')
      return favorites ? JSON.parse(favorites) : []
    } catch (error) {
      console.error('Failed to parse favorite games from localStorage:', error)
      return []
    }
  }

  addGameToFavorites = gameId => {
    const { favoriteGames, games } = this.state
    let gameToAdd = games.find(game => game.Id === gameId)

    const updatedFavorites = [...favoriteGames, gameToAdd]
    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }

  removeGameFromFavorites = gameId => {
    const updatedFavorites = this.state.favoriteGames.filter(game => game.Id !== gameId)
    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }

  unpinGame = async gameId => {
    const user = this.props.user

    if (!user) {
      alert('Зарегистрируйтесь для того чтобы удалить из избранных')
      return
    }

    const gamblerId = user.get('gamblerId')

    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы удалить из избранных')
      return
    }

    try {
      const response = await fetch(`/api/games/un-pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.removeGameFromFavorites(gameId)
      } else {
        console.error('Failed to unpin the game')
      }
    } catch (error) {
      console.error('Error unpinning the game:', error)
    }
  }

  pinGame = async gameId => {
    const user = this.props.user

    if (!user) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    const gamblerId = user.get('gamblerId')

    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    try {
      const response = await fetch(`/api/games/pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.addGameToFavorites(gameId)
      } else {
        this.removeGameFromFavorites(gameId)
      }
    } catch (error) {
      console.error('Error pinning the game:', error)
    }
  }

  render() {
    const { games, category, isLoading, showSignIn } = this.state

    return (
      <div className="game-types-page">
        {showSignIn && <SignIn />}
        <Link to="/games">
          <button className="view-all-button">
            <FormattedMessage {...messages.goBackToGames} />
          </button>
        </Link>

        {category && (
          <h1 className="page-title">
            <FormattedMessage {...messages.allGamesForCategory} />: {games[0].GameType || 'Категория'}
          </h1>
        )}
        <div className="game-list">
          {games.length > 0 ? (
            games.map(game =>
              renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.pinGame, this.unpinGame)
            )
          ) : (
            <div className="no-games-message">
              <Loader />
            </div>
          )}
        </div>
        {isLoading && <Loader />}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.get('user'),
})

export default withRouter(connect(mapStateToProps)(GameTypesPage))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/GamesTypesPage/GamesTypesPage.jsx